import React, { useState } from 'react';
import { Pressable, Platform } from 'react-native';
import { Link, useRouter } from 'expo-router';
import Text from '@/components/Typography/Text';
import useBusinessBrand from './businessBrand';

// Neutral call to action for Business pages: black fill with a white label
// (inverted in dark appearance) for the one primary action, and a bordered
// neutral button for everything else. No glow, gradient or pill shape.
export default function BusinessCta({ label, href, secondary = false }) {
  const b = useBusinessBrand();
  const router = useRouter();
  const [hovered, setHovered] = useState(false);
  const web = Platform.OS === 'web';
  const button = (
    <Pressable
      accessibilityRole="link"
      accessibilityLabel={label}
      onPress={web ? undefined : () => router.push(href)}
      onHoverIn={() => setHovered(true)}
      onHoverOut={() => setHovered(false)}
      style={{
        minHeight: 48, paddingHorizontal: 24, borderRadius: 12, alignSelf: 'flex-start',
        alignItems: 'center', justifyContent: 'center', borderWidth: 1,
        borderColor: secondary ? b.edge : b.ink,
        backgroundColor: secondary ? (hovered ? b.fill : b.page) : b.ink,
        opacity: !secondary && hovered ? 0.88 : 1,
        ...(web ? { cursor: 'pointer', transition: 'background-color 150ms ease, opacity 150ms ease' } : {}),
      }}
    >
      <Text weight="semibold" style={{ color: secondary ? b.ink : b.page, fontSize: 16 }}>{label}</Text>
    </Pressable>
  );
  return web && href ? <Link href={href} asChild>{button}</Link> : button;
}
